/**
 * 教师端静态路由（对齐 getRouters 响应结构，供菜单 transformRouters 使用）
 * 实际 Vue Router 注册见 src/router/teacherStaticRoutes.js
 */

export const TEACHER_STATIC_ROUTERS = [
  {
    menuType: "C",
    path: "/",
    hidden: false,
    component: "Layout",
    children: [
      {
        name: "/home",
        path: "/home",
        hidden: false,
        component: "views/home/index",
        meta: {
          title: "首页",
          icon: "#",
          noCache: false,
          link: null
        }
      }
    ]
  },
  {
    menuType: "C",
    path: "/",
    hidden: false,
    component: "Layout",
    children: [
      {
        name: "/course",
        path: "/course",
        hidden: false,
        component: "views/Course/index",
        meta: {
          title: "课程管理",
          icon: "#",
          noCache: false,
          link: null
        }
      }
    ]
  },
  {
    menuType: "M",
    name: "Question",
    path: "/question",
    hidden: false,
    redirect: "noRedirect",
    component: "Layout",
    alwaysShow: true,
    meta: {
      title: "题库管理",
      icon: "#",
      noCache: false,
      link: null
    },
    children: [
      {
        menuType: "C",
        name: "Theory",
        path: "theory",
        hidden: false,
        component: "QuestionBank/index",
        meta: {
          title: "理论题库",
          icon: "#",
          noCache: false,
          link: null
        }
      },
      {
        menuType: "C",
        name: "Practical",
        path: "practical",
        hidden: false,
        component: "QuestionBank/index",
        meta: {
          title: "实操题库",
          icon: "#",
          noCache: false,
          link: null
        }
      }
    ]
  },
  {
    menuType: "C",
    path: "/",
    hidden: false,
    component: "Layout",
    children: [
      {
        name: "/Knowledge",
        path: "/Knowledge",
        hidden: false,
        component: "views/Knowledge/index",
        meta: {
          title: "知识库",
          icon: "#",
          noCache: false,
          link: null
        }
      }
    ]
  },
  {
    menuType: "C",
    path: "/",
    hidden: false,
    component: "Layout",
    children: [
      {
        name: "/news",
        path: "/news",
        hidden: false,
        component: "views/News/index",
        meta: {
          title: "新闻管理",
          icon: "#",
          noCache: false,
          link: null
        }
      }
    ]
  }
];

export default TEACHER_STATIC_ROUTERS;



// WEBPACK FOOTER //
// ./src/config/teacherStaticRouters.js